import classNames from 'classnames';
import { memo } from 'react';

interface DraftJobPillProps {
  jobName: string | null;
  jobPillHeight: number;
  columnWidth: number;
  jobPillMargin: number;
  transform: string;
}

/**
 * DraftJobPill - Renders the draft job pill during job creation.
 * Memoized to prevent re-renders during scroll.
 */
export const DraftJobPill = memo(function DraftJobPill({
  jobName,
  jobPillHeight,
  columnWidth,
  jobPillMargin,
  transform,
}: DraftJobPillProps) {
  const displayName = jobName && jobName.trim() ? jobName : 'New Job';

  return (
    <div
      style={{
        position: 'absolute',
        transform,
        zIndex: 15,
      }}
      className='hover:cursor-pointer'
    >
      <div
        className={classNames(
          'border-0.5 border-status-stroke-created bg-status-created text-gray-900',
          'group flex flex-col items-stretch justify-between overflow-hidden text-xs leading-5',
          'rounded-md px-2',
          'ring-1 ring-brand-lighter'
        )}
        style={{
          height: jobPillHeight,
          width: Math.max(0, columnWidth - jobPillMargin),
        }}
      >
        <div>
          <div className='flex justify-between'>
            <p className='truncate font-medium'>{displayName}</p>
          </div>
          <div className='flex justify-between pt-0.5'>
            <div>Creating...</div>
          </div>
        </div>
      </div>
    </div>
  );
});

DraftJobPill.displayName = 'DraftJobPill';
